import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UpsellBaseModal } from '../CampaignUpsellModals/UpsellBaseModal';
import { CAMPAIGN_EVALUATION_REWARD_ARTS } from '../../utils/campaignEvaluationSession';
import styles from './styles.module.css';

const GiftIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20 12V20H4V12M2 7H22V12H2V7ZM12 20V7M12 7H8.5C7.57 7 6.68 6.63 6.05 6C5.42 5.37 5.05 4.48 5.05 3.55C5.05 2.62 5.42 1.73 6.05 1.1C6.68 0.47 7.57 0.1 8.5 0.1C10.71 0.1 12 2.24 12 2.24C12 2.24 13.29 0.1 15.5 0.1C16.43 0.1 17.32 0.47 17.95 1.1C18.58 1.73 18.95 2.62 18.95 3.55C18.95 4.48 18.58 5.37 17.95 6C17.32 6.63 16.43 7 15.5 7H12Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CampaignEvaluationRewardModal = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      className={styles.rewardModal}
      title={t('chatsocket.avaliation.reward_title', {
        count: CAMPAIGN_EVALUATION_REWARD_ARTS,
      })}
      titleId="campaign-evaluation-reward-title"
      contentClassName={styles.rewardContent}
      headerIcon={(
        <div className={styles.rewardGiftIcon}>
          <GiftIcon />
        </div>
      )}
      primaryAction={{
        label: t('chatsocket.avaliation.reward_cta'),
        onClick: onClose,
      }}
      showCloseButton={false}
    >
      <p className={styles.rewardBody}>
        {t('chatsocket.avaliation.reward_body', {
          count: CAMPAIGN_EVALUATION_REWARD_ARTS,
        })}
      </p>
    </UpsellBaseModal>
  );
};

CampaignEvaluationRewardModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
